const initState = {
    successFetching: false,
    errorFetching: false,
    coverage: null,
    schedule: null,
    typeAddress: null,
    status:null
  };
  
  export default initState;
  